var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Arrow } from './styles';
export var ChevronArrow = function (_a) {
  var _b = _a.size,
    size = _b === void 0 ? 12 : _b,
    props = __rest(_a, ["size"]);
  return _jsx(Arrow, __assign({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    "data-cy-label": "arrow"
  }, props, {
    children: _jsx("path", {
      d: "M13.324 18.14 23.469 8.05A1.783 1.783 0 0 0 24 6.784a1.771 1.771 0 0 0-.531-1.266 1.803 1.803 0 0 0-2.532 0l-8.978 8.825L3.07 5.518a1.802 1.802 0 0 0-2.531 0A1.783 1.783 0 0 0 0 6.784 1.77 1.77 0 0 0 .539 8.05l10.145 10.09a1.795 1.795 0 0 0 1.32.574 1.804 1.804 0 0 0 1.32-.574Z"
    })
  }));
};